import { GUESTBOOK_CLUSTER_SIZE } from "../../shared/guestbook.js";

const NOTE_TONES = ["sun", "sea", "clay", "night", "plum", "sage", "sky", "sand"] as const;

export type WallNotePresentation = {
  slot: number;
  tone: (typeof NOTE_TONES)[number];
  tilt: number;
};

export function wallClusters<T>(entries: readonly T[], size = GUESTBOOK_CLUSTER_SIZE): T[][] {
  if (!Number.isSafeInteger(size) || size < 1) throw new Error("Wall cluster size must be a positive integer.");
  const result: T[][] = [];
  for (let index = 0; index < entries.length; index += size) result.push(entries.slice(index, index + size));
  return result;
}

export function wallNotePresentation(entryId: number, index: number): WallNotePresentation {
  const seed = Math.abs(Math.trunc(entryId * 37 + index * 19));
  return {
    slot: index % GUESTBOOK_CLUSTER_SIZE,
    tone: NOTE_TONES[(Math.abs(Math.trunc(entryId)) + index * 2) % NOTE_TONES.length]!,
    tilt: ((seed % 19) - 9) / 10,
  };
}
